import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, WorkRole } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'code-material-picker',
    templateUrl: './code.material.picker.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: CodeMaterialPickerComponent, multi: true }
    ],
    standalone: false
})
export class CodeMaterialPickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Code Material>';
  @Input() public appendTo;
  @Input() public multiple: boolean;

  public data$: Observable<Entity[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getCodes()
      : of(this.data);

  }

  private getCodes(): Observable<Entity[]> {
    return this.http.get<WorkRole[]>('/api/picker/code/material');
  }
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  declarations: [
    CodeMaterialPickerComponent
  ],
  providers: [],
  exports: [
    CodeMaterialPickerComponent
  ],
})
export class CodeMaterialPickerModule { }
